import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.588 11.2q-.63 0-1.08-.411t-.45-.989V1.4q0-.578.45-.989T4.588 0h6.883q.63 0 1.08.411T13 1.4v8.4q0 .578-.45.989-.448.411-1.08.411zm0-1.4h6.883V1.4H4.588zM1.53 14q-.63 0-1.08-.411T0 12.6V2.8h1.53v9.8h8.41V14z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
